export default {
  services: {
    account: {
      name: 'Account service'
    }
  }
}